import { useState } from "react";

export const faqs = [
  {
    question: "Quelle largeur de sangle faut-il choisir ?",
    answer:
      "La largeur de la sangle dépend du poids et des dimensions de votre tablier. La sangle de 14 mm convient aux volets standards de petite et moyenne taille. La sangle de 22 mm est recommandée pour les grands volets ou les tabliers lourds en aluminium ou PVC renforcé. Notre technicien mesure sur place et vous conseille la sangle adaptée.",
  },
  {
    question: "Combien de temps dure le remplacement d'une sangle ?",
    answer:
      "Le remplacement d'une sangle de volet roulant dure généralement moins d'une heure. C'est une intervention rapide qui ne nécessite pas de démontage complet du coffre. Nous remplaçons la sangle, vérifions l'enrouleur et le guidage, et testons le bon fonctionnement du volet avant de repartir.",
  },
  {
    question: "Réparez-vous l'enrouleur aussi ou seulement la sangle ?",
    answer:
      "Nous inspectons systématiquement l'enrouleur à chaque remplacement de sangle. Si l'enrouleur est bloqué, faible ou si son ressort est usé, nous vous proposons la réparation ou le remplacement. Remplacer une sangle neuve sur un enrouleur défectueux serait inefficace : la sangle s'userait à nouveau très vite.",
  },
  {
    question: "Quel est le prix du remplacement d'une sangle ?",
    answer:
      "Le prix dépend de la largeur de la sangle (14 mm ou 22 mm), de l'accessibilité du coffre et de l'état des pièces associées. Nous établissons un devis gratuit et transparent sur place avant toute intervention. Il n'y a aucun frais caché et vous êtes libre d'accepter ou de refuser.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Questions fréquentes — remplacement de sangle
        </h2>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border border-[#E2E8F0] overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left"
              >
                <span className="text-[#143A66] text-base font-semibold">{faq.question}</span>
                <span className="w-8 h-8 flex items-center justify-center shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-[#00B3A4] text-xl transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-[#2F4A63] text-base leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}